import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import { isMobile } from 'react-device-detect';
import AppContext from '../../../contexts/AppContext';
import './BottomNav.css';
const useStyles = makeStyles((theme) => ({
  partnerLogo: {},
  logoContainer: {
    marginLeft: theme.spacing(2),
  },
}));

export default function BottomNav({
  selectedItem,
  // selectedObject,
  //onOpacityHandler,
  onDeleteIconHandler,
  showTrash,
}) {
  const classes = useStyles();

  const { axl } = useContext(AppContext);
  const onClickLinkHandler = (url) => {
    if (axl) {
      const AxL = require('../../../utils/Axl').default;
      axl.sendMessage(AxL.ChildToHost.NAVIGATE, url);
      return;
    }
  };

  let leftText = [];

  // ----- various options for mobile / desktop and public/private mode
  if (selectedItem) {
    const variant = isMobile ? 'caption' : 'body1';
    if (isMobile) {
      const title = selectedItem.year
        ? '(' + selectedItem.year + '), ' + selectedItem.city
        : selectedItem.city;
      leftText = (
        <>
          <Box display="flex">
            <Box fontWeight="fontWeightBold">
              <Typography variant={variant}>
                {selectedItem.creator} {title}
                {selectedItem.collection_title
                  ? ', ' + selectedItem.collection_title
                  : null}
              </Typography>
            </Box>
          </Box>
          <Typography variant={variant}>
            <Link
              onClick={() => {
                onClickLinkHandler('asset/' + selectedItem.asset_id);
              }}
            >
              {selectedItem.title}
            </Link>
          </Typography>
        </>
      );
    } else {
      const title = selectedItem.year
        ? '(' + selectedItem.year + '), ' + selectedItem.city
        : selectedItem.city;
      leftText = (
        <>
          <Box display="flex">
            <Box fontWeight="fontWeightBold">
              <Typography variant={variant}>
                {selectedItem.creator}{' '}
                {selectedItem.collection_title
                  ? ', ' + selectedItem.collection_title
                  : null}
              </Typography>
            </Box>
            &nbsp;
            <Typography variant={variant}> {title}</Typography>
          </Box>
          <Typography variant={variant}>
            <button
              className="btn-link"
              onClick={() => {
                onClickLinkHandler('asset/' + selectedItem.asset_id);
              }}
            >
              {selectedItem.title}
            </button>
          </Typography>
        </>
      );
    }
  }

  const rectangles = [];
  if (selectedItem && selectedItem.palette) {
    selectedItem.palette.forEach((item) => {
      /*
      const style = {
        background: item.color,
        width: `${item.weight * 100}%`,
        height: isMobile ? '10px' : '20px',
        marginTop: '14px',
      };
      */
      rectangles
        .push
        // <div key={item.color} className="color-rectangle" style={style}></div>,
        ();
    });
  }

  let middleText = [];
  if (selectedItem) {
    middleText = (
      <>
        <Box display="flex">{rectangles}</Box>
      </>
    );
  }

  let endText = [];
  if (selectedItem) {
    if (isMobile) {
      endText = (
        <>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            className={classes.logoContainer}
          >
            {selectedItem.partner_logo && (
              <img
                alt={selectedItem.creator}
                className={'bottom-img-logo'}
                height={40}
                src={selectedItem.partner_logo}
              />
            )}
          </Box>
        </>
      );
    } else {
      endText = (
        <>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            className={classes.logoContainer}
          >
            {selectedItem.partner_logo && (
              <img
                className={classes.partnerLogo}
                alt={selectedItem.creator}
                height={40}
                src={selectedItem.partner_logo}
              />
            )}
          </Box>
        </>
      );
    }
  }

  let content;

  if (isMobile) {
    content = (
      <>
        <Grid item xs={8}>
          {leftText}
        </Grid>
        <Grid item xs={4}>
          {endText}
        </Grid>
        <Grid item xs={12}>
          {middleText}
        </Grid>
      </>
    );
  } else {
    content = (
      <>
        <Grid item xs={showTrash ? 9 : 11}>
          {leftText}
        </Grid>

        <Grid item xs={showTrash ? 2 : 1}>
          {endText}
        </Grid>
        {showTrash && (
          <Grid item xs={1}>
            <Box display="flex" alignItems="center" justifyContent="flex-end">
              <Fab
                onClick={() => {
                  onDeleteIconHandler(true);
                }}
                color="secondary"
                aria-label="add"
                size="medium"
              >
                <DeleteIcon />
              </Fab>
            </Box>
          </Grid>
        )}
      </>
    );
  }

  return content;
}
